// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3_l0D","addWidgetButton":"Header_addWidgetButton__3pVzv","dashboardTabs":"Header_dashboardTabs__2GXoy","active":"Header_active__3ZDKE"};